import {Injectable} from "@angular/core";
import {Observable, ReplaySubject} from "rxjs";

@Injectable()
/** a "Service" or "Repo" of sorts, to store/cache generic Data without an API involved, which is useful for a great many things.
 * Implementing classes should ideally be dependency-injected using only ViewProviders, there should not be a general purpose singleton.
 * We call any class implementing this a "Share". */

export abstract class SharedData {
    private _data: {[s: string]: ReplaySubject<any>} = {};

    storeData(id: string, value: any): void {
        if (this._data[id] === undefined){
            this._data[id] = new ReplaySubject(1);
        }
        this._data[id].next(value);
    }

    getData(id: string): Observable<any>{
        if (this._data[id] === undefined){
            this._data[id] = new ReplaySubject(1);
        }
        return this._data[id].asObservable();
    }

}